import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useClientCompanies from '../../stores/useClientCompanies';
import Heading from '../../components/Heading';
import Skeleton from '../../components/ui/skeleton';

export default function ClientRunning() {
  const { t } = useTranslation();
  const { clients, fetchClients, hasFetched, fetchLoading } = useClientCompanies();

  useEffect(() => {
    if (!fetchLoading && !hasFetched) {
      fetchClients();
    }
  }, [fetchClients, hasFetched, fetchLoading]);

  const safeClients = clients || [];
  const duplicatedClients = [...safeClients];

  return (
    <section className="enable-animation main__container my-8 md:my-12">
      <div className="flex flex-col gap-3 items-center mb-3 px-3">
        <Heading>{t('general.clients')}</Heading>
        <p className="text-center sm:text-sm text-xs">{t('tagline.home.clients')}</p>
      </div>
      {fetchLoading ? (
        <div className="marquee">
          <div className="marquee__content p-3">
            {Array.from({ length: 10 }).map(() => (
              <Skeleton
                key={Math.random()}
                className="marquee__item sm:w-52 w-48 flex flex-col items-center justify-between transition-all duration-200 cursor-pointer  bg-white animate-scale-in rounded-lg drop-shadow-md"
              >
                <Skeleton className="sm:w-24 sm:h-24 w-16 h-16 bg-neutral-200" />
                <Skeleton className="sm:w-24 w-16 h-3 bg-neutral-200" />
              </Skeleton>
            ))}
          </div>
        </div>
      ) : (
        <div className="marquee">
          <ul className="marquee__content p-3">
            {safeClients.map((client) => (
              <li
                key={`duplicate-${client?.partnercom_id}`}
                className="marquee__item border-border border sm:w-52 w-48 flex flex-col items-center justify-between transition-all duration-200 cursor-pointer  bg-white animate-scale-in rounded-lg hover-shadow shadow-md"
              >
                <img
                  src={client?.logo_prt || '/assets/no-data-image.png'}
                  alt={client?.name_prt || 'Client'}
                  className="sm:w-24 sm:h-24 w-16 h-16 object-contain"
                />
                <h3 title={client?.name_prt} className=" text-xs text-wrap text-center font-semibold">
                  {client?.name_prt || 'No Name'}
                </h3>
              </li>
            ))}
          </ul>

          <ul aria-hidden="true" className="marquee__content p-3">
            {duplicatedClients.map((client) => (
              <li
                key={`duplicate-${client?.partnercom_id}`}
                className="marquee__item border-border border sm:w-52 w-48 flex flex-col items-center justify-between gap-2 transition-all duration-200 cursor-pointer  bg-white animate-scale-in rounded-lg hover-shadow shadow-md"
              >
                <img
                  src={client?.logo_prt || '/assets/no-data-image.png'}
                  alt={client?.name_prt || 'Client'}
                  className="sm:w-24 sm:h-24 w-16 h-16 object-contain"
                />
                <h3 title={client?.name_prt} className=" text-xs text-wrap text-center font-semibold">
                  {client?.name_prt || 'No Name'}
                </h3>
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
}
